import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { useDownloadBatchReport, useDownloadBatchZipReport } from '../../shared/mutations/batchReports';
import { useDownloadJournalFile } from '@mutations/journalFile';
import { JobConfig } from '../../shared/jim/propTypes';
import { showJobErrorsModal } from './store/actions';
import { Job } from './types';
import { downloadResponseFile, downloadResponseZipFile } from './downloadResponseFile';
import { shouldDownloadJobAsZip } from './helpers';

type ShowErrorsLinkProps = {
  returnedError: Job['returnedError'],
}

export const ShowErrorsLink: FC<ShowErrorsLinkProps> = ({ returnedError }: ShowErrorsLinkProps) => {
  const dispatch = useDispatch();
  const showModal = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    dispatch(showJobErrorsModal(returnedError));
  }, [dispatch, returnedError]);

  return (
    <a
      className="text-white a-text-underline"
      href="#"
      onClick={showModal}
    >Show Errors
    </a>
  );
};

type DownloadFileLinkProps = {
  job: Job,
  isZipFile?: boolean,
}

export const DownloadFileLink: FC<DownloadFileLinkProps> = ({ job, isZipFile }: DownloadFileLinkProps) => {
  const jobLabel = job.returnedValue?.filename || job.jobType;
  const jobType = job.jobType;
  const shouldDownloadAsZip = shouldDownloadJobAsZip(job, isZipFile);

  const { mutate: downloadFile }
    = (jobType === 'generate-journal-file')
      ? useDownloadJournalFile(downloadResponseFile(jobLabel))
      : useDownloadBatchReport(shouldDownloadAsZip
        ? downloadResponseZipFile(jobLabel)
        : downloadResponseFile(jobLabel));

  const { mutate: downloadZipFile } = useDownloadBatchZipReport(downloadResponseZipFile(jobLabel));

  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (isZipFile) {
      downloadZipFile({ fileName: jobLabel });
    } else {
      downloadFile({
        jobId: job.jobId,
        exportFormat: job.returnedValue?.exportFormat,
      });
    }
  };

  return (
    <a
      className="text-white a-text-underline"
      href="#"
      onClick={handleOnClick} // eslint-disable-line react/jsx-no-bind
    >Download file
    </a>
  );
};

type NavigateToPageLinkProps = {
  jobConfig: JobConfig,
}
export const NavigateToPageLink: FC<NavigateToPageLinkProps> = ({ jobConfig }: NavigateToPageLinkProps) => {
  const history = useHistory();
  const handleNavigate = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    history.push(jobConfig.page!);
  }, [history, jobConfig.page]);

  return (
    <a
      className="text-white a-text-underline"
      href="#"
      onClick={handleNavigate}
    >Go to the page
    </a>
  );
};
